<app-page-wrapper [title]="'imports' | i18n">
  <div>
    <app-spinner [showSpinner]="isImporting"></app-spinner>
    <div class="content" *ngIf="!isImportComplete">
      <div class="page-header">
        <h1>{{ "importReferenceData" | i18n }}</h1>
      </div>
      <form [formGroup]="currencyForm" ngNativeValidate>
        <!-- Currency Import Form -->
        <fieldset>
          <!--        <legend>{{ "importCurrencyData" | i18n }}</legend>-->
          <div class="file-input-container">
            <button type="button" mat-raised-button (click)="currencyCsvReader.click()">
              {{ "chooseFile" | i18n }}
            </button>
            <input
              type="file"
              #currencyCsvReader
              id="currencyFileReader"
              formControlName="currencyCsvFile"
              accept=".csv,.xlsx,.xls"
              aria-describedby="file-upload-description"
              [hidden]="true"
              [required]="true"
              (change)="uploadListener($event)"
            />
            <span id="currency-file-upload-description">{{
              selectedCurrencyFileName || ("noFileChosen" | i18n)
            }}</span>
          </div>
          <br />
          <!--        <button-->
          <!--          mat-raised-button-->
          <!--          color="primary"-->
          <!--          type="button"-->
          <!--          [disabled]="!selectedCurrencyFileName"-->
          <!--          (click)="submit('currencyFileReader')"-->
          <!--        >-->
          <!--          <span>{{ "importCurrencyData" | i18n }}</span>-->
          <!--        </button>-->
          <button
            mat-raised-button
            color="primary"
            type="button"
            [disabled]="!selectedCurrencyFileName"
            (click)="preview('currencyFileReader')"
          >
            <span>{{ "previewData" | i18n }}</span>
          </button>
        </fieldset>
      </form>

      <!-- CSV Preview (spreadsheet-style, scrollable) -->
      <div class="preview-container" *ngIf="previewHeaders?.length">
        <h2>{{ "previewData" | i18n }} ({{ previewRows.length }} rows)</h2>
        <!-- Focusable (tabindex + region) so keyboard users can scroll the preview too. -->
        <div
          class="preview-grid-scroll"
          tabindex="0"
          role="region"
          [attr.aria-label]="'previewData' | i18n"
          [appScrollLock]="lockPageScroll"
          (mouseenter)="lockPageScroll = true"
          (mouseleave)="lockPageScroll = false"
        >
          <table class="preview-grid">
            <thead>
              <tr>
                <th class="row-index">#</th>
                <th *ngFor="let header of previewHeaders">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewRows; let i = index">
                <td class="row-index">{{ i + 1 }}</td>
                <td *ngFor="let header of previewHeaders; let c = index">{{ row[c] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</app-page-wrapper>
